import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { get as getProjection } from "ol/proj";
import TileGrid from "ol/tilegrid/TileGrid.js";

// Define a new projection using Proj4js and register it
proj4.defs("EPSG:3008", "+proj=tmerc +lat_0=0 +lon_0=13 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);

// Define resolutions for the map tiles
export const resolutions = [
  66.6751333502667, 33.86673440013547, 25.400050800101603, 16.933367200067735, 12.700025400050801, 8.466683600033868, 4.233341800016934,
  2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.26458386250105836, 0.13229193125052918, 0.06614596562526459,
  0.026458386250105836,
];

// Define the extent of the map in the EPSG:3008 projection
export const extent = [34364.701176279224, 6105850.2404539045, 180404.6059212964, 6198940.128187204];

export const initialCenter = [120844, 6161226];
export const initialZoom = 5;

// Get the projection object for EPSG:3008 and set its extent
export const projection = getProjection("EPSG:3008");
projection.setExtent(extent);

// Define a tile grid for the map, specifying its origin, resolutions, and extent
export const tileGrid = new TileGrid({
  origin: [-399.9999999999999, 9006799.254740989],
  resolutions: resolutions,
  extent: extent,
});

export const backgroundMapUrl = "https://gis.malmo.se/arcgis/rest/services/baskartor/Bakgrundskarta_nedtonad_3008_text/MapServer/tile/{z}/{y}/{x}";

export const searchUrl = "https://geo.malmo.se/api/search";

// Limits for drawing, keeps the map link at a reasonable length
export const maxDrawFeatures = 10; // Max number of drawn features
export const maxDrawPoints = 25; // Max number of points per line or polygon
export const drawDecimals = 1; // Coordinate decimals in the URL (EPSG:3008 is in meters)
export const maxDrawUrlLength = 20000; // Max length of a drawing read from the URL, leaves room for older full precision links